import { Link, useNavigate } from 'react-router-dom';
import right from '../icons/images/right.png';
import docta from '../images/docta.jpg';
import point from '../icons/images/point.png';
import coeur from '../icons/images/coeur.png';
import coeurv from '../icons/images/coeurv.png';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import axios from 'axios';
import { Quelquegroupe } from '../skeletons/quelquegroupe';
import { useContext, useState } from 'react';
import { tokenContexte } from '../contexte/tokenContexte';
import { userContexte } from '../contexte/userContexte';
import { PrototypeSkeleton } from '../skeletons/prototype';
import { toast, ToastContainer } from 'react-toastify';

export function SuggestionPrototype()
{
  const tab=['','','','','','','','','','','','','','']
   const queryClient=useQueryClient();
   // liker un groupe suggestion
  //  const likeramensuggestion=(id,c)=>{
  //   if(document.getElementById(id+'iconcoeursuggestion'+c).src==coeur){
  //     document.getElementById(id+'iconcoeursuggestion'+c).src=coeurv
  //      document.getElementById(id+'iconcoeursuggestion'+c).style.transform='scale(1.2)'
  //   }else{
  //     document.getElementById(id+'iconcoeursuggestion'+c).src=coeur
  //      document.getElementById(id+'iconcoeursuggestion'+c).style.transform='scale(1)'
  //   }
  
  // }

  const navigate=useNavigate()
  const {token}=useContext(tokenContexte)
 
  const {data:prototypes,isLoading}=useQuery({
    queryKey:['liste-prototype'],
    queryFn:()=>axios.get(`${process.env.REACT_APP_BACKEND_URL}/liste-prototype`)
  })

    const mutationpostamen=useMutation({
        mutationFn:()=>{
           
        },
          onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['liste-publication-auth'] });
            queryClient.invalidateQueries({ queryKey: ['notification-nonlue'] });
          },
          // onError:()=>navigate('/login')
      })

       const [type, setType]=useState('amen')
       const [portee, setPortee]=useState('monde')
       const [cible, setCible]=useState(null)
  const publier=(id,idbouton,photo,texte,theme)=>{
    document.getElementById(idbouton).textContent='publication...'
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/post-actualite-prototype`,{type,texte,portee,photo,cible,theme},{
                  headers:{
                    "Authorization": "Bearer "+token,
                  }
                }).then((res)=>{
                    console.log(res.data)
       if(res?.data?.statut=='200'){
        document.getElementById(idbouton).textContent='publication réussie'
       toast('Publication réussie')
       mutationpostamen.mutate()
       }else{
      
       }
     }).catch((err)=>{
        console.log(err)
      if(err.response?.data?.message?.includes('Unauthenticated')){
        navigate('/login')
    }
     })
   
 }

 



    // const publier=(id,idbouton,photo,texte,theme)=>{
    // document.getElementById(idbouton).textContent='publication...'
    //     toast('publication en cours...')
    //     mutationpostamen.mutate()
    //   }

  const {userstore}=useContext(userContexte)
    return <>
    <ToastContainer/>
    <div className='flex flex-col justify-center items-start w-full'>
    <p style={{display:prototypes && prototypes?.data?.pubs?.length==0 ? 'none' : 'block'}} className="p-3 text-sm"> Quelques messages édifiants</p>
    <div className='w-full flex flex-row justify-between items-center gap-x-4 overflow-x-auto px-2'>
    {
           prototypes ? prototypes?.data?.pubs?.map((c,i)=>{
                return <div class="" style={{width:'18rem',height:'auto'}}>
               <div style={{backgroundImage:`url(${process.env.REACT_APP_BACKEND_FILE+c.photo})`,backgroundPosition:'center',backgroundSize:'cover',height:'12rem'}}></div>
               <div style={{width:'18rem',height:'16rem'}} class="card-body bg-white flex flex-col justify-between">
                  <h5 class="card-title font-bold text-violet-700">{c.theme?.length>50 ? c.theme?.substr(0,50)+'...' : c?.theme}</h5>
                  <p class="card-text gap-y-2 flex flex-col"> <span><span className=" text-violet-700">Message : </span>{c.message?.length>130 ? c.message?.substr(0,130)+'...' : c.message}</span>  </p>
                  <span className="flex flex-row w-full">
               
                 <Link id={'publier'+i} onClick={()=>{publier(c.id, 'publier'+i,c.photo,c.message,c.theme)}} class="btn focus:bg-violet-600 bg-violet-700 text-white mt-1 hover:bg-violet-600 text-xs w-full">Publier</Link>
                 </span>
                </div>
              </div>
            }) : <PrototypeSkeleton/>
        }
</div>
{/* <span style={{display:prototypes && prototypes?.data?.pubs?.length==0 ? 'none' : 'block'}} className=' w-full mt-2'><Link to={'/groupes'} className='flex flex-row justify-center items-center gap-x-2 text-decoration-none hover:text-violet-700'><span>Voir plus</span> <img className='voirplusfriend' style={{height:'13px'}}  src={right} alt="" /></Link></span> */}
</div>
    </>
}